import { motion, useReducedMotion } from "framer-motion";

export default function Mascot({ className }: { className?: string }) {
  const reduce = useReducedMotion();
  return (
    <motion.svg
      viewBox="0 0 120 120"
      className={className}
      aria-hidden="true"
      focusable="false"
      animate={reduce ? undefined : { y: [0, -9, 0] }}
      transition={reduce ? undefined : { duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
    >
      <ellipse cx="60" cy="110" rx="34" ry="6" fill="rgba(35,32,30,.12)" />
      <path d="M60 34 C60 20 70 12 82 14 C78 24 70 30 60 34 Z" fill="#1FB6A6" />
      <rect x="24" y="30" width="72" height="72" rx="30" fill="#FF8A5B" />
      <circle cx="47" cy="60" r="7" fill="#fff" />
      <circle cx="73" cy="60" r="7" fill="#fff" />
      <circle cx="48" cy="61" r="3.4" fill="#23201E" />
      <circle cx="74" cy="61" r="3.4" fill="#23201E" />
      <path d="M50 76 Q60 86 70 76" stroke="#23201E" strokeWidth="4" fill="none" strokeLinecap="round" />
    </motion.svg>
  );
}
